module.exports = __webpack_public_path__ + "static/tusas-motor-1-bd71965761c40bb47ac8cf4afbb05055.jpg";